import { toast, ToastOptions } from 'react-toastify';

// Default toast configuration
const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Display success toast message
export const showSuccessToast = (message: string, options?: ToastOptions) => {
  return toast.success(message, { ...defaultOptions, ...options, hideProgressBar: true });
};

// Display error toast message
export const showErrorToast = (message: string, options?: ToastOptions) => {
  return toast.error(message, { ...defaultOptions, ...options, hideProgressBar: true });
};

// Display info toast message
export const showInfoToast = (message: string, options?: ToastOptions) => {
  return toast.info(message, { ...defaultOptions, ...options, hideProgressBar: true });
};

// Display warning toast message
export const showWarningToast = (message: string, options?: ToastOptions) => {
  return toast.warning(message, { ...defaultOptions, ...options, hideProgressBar: true });
}; 